<template>
    <div class="pp-lottery-winnings">
        <DsDropdown v-model="selectedOption" :options="options" id="pp-lottery-winnings-dropdown" />
        <DsTable>
            <DsRow>
                <DsCell type="th">Uhodnutá čísla</DsCell>
                <DsCell type="th">Výherní násobek</DsCell>
                <DsCell type="th">Násobek s královskou hrou</DsCell>
            </DsRow>
            <DsRow v-for="(order, index) in winningOrdersGrid[selectedOption]" :key="index">
                <DsCell>{{ order[0] }}</DsCell>
                <DsCell><span v-html="formatMultiple(order[1])"></span></DsCell>
                <DsCell><strong v-html="formatMultiple(order[2])"></strong></DsCell>
            </DsRow>
        </DsTable>
        <PpSpecialPrizeWinnings
            :lottery="Lottery.stastnych10"
            :specialPrizes="results.specialPrizes"
        ></PpSpecialPrizeWinnings>
    </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { PpDraw } from "@/lotteries/services/model/draw";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";

defineProps<{
    results: PpDraw;
}>();

const config = usePpWagerConfiguration().config;

const options = Array.from({ length: config.primaryBoardSize }, (_, index) => ({
    value: index,
    label: `SÁZKA NA ${config.primaryBoardSize - index} ${LotteryParser.getNumberLabel(
        config.primaryBoardSize - index
    ).toUpperCase()}`,
}));

const selectedOption = ref(0);

const winningOrdersGrid = [
    [
        [10, 200000, 300000],
        [9, 10000, 15000],
        [8, 500, 750],
        [7, 20, 30],
        [6, 10, 15],
        [5, 3, 6],
        [4, null, 2],
        [3, null, 2],
        [2, null, 2],
        [1, null, 6],
    ],
    [
        [9, 50000, 75000],
        [8, 2000, 3000],
        [7, 200, 300],
        [6, 20, 30],
        [5, 3, 6],
        [4, null, 2],
        [3, null, 2],
        [2, null, 2],
        [1, null, 7],
    ],
    [
        [8, 20000, 30000],
        [7, 400, 1000],
        [6, 40, 100],
        [5, 4, 15],
        [4, 1, 5],
        [3, null, 2],
        [2, null, 2],
        [1, null, 3],
    ],
    [
        [7, 4000, 6000],
        [6, 100, 200],
        [5, 10, 20],
        [4, 2, 10],
        [3, null, 4],
        [2, null, 3],
        [1, null, 3],
    ],
    [
        [6, 600, 1500],
        [5, 20, 50],
        [4, 2, 10],
        [3, 1, 5],
        [2, null, 5],
        [1, null, 5],
    ],
    [
        [5, 200, 400],
        [4, 16, 30],
        [3, 2, 10],
        [2, null, 5],
        [1, null, 5],
    ],
    [
        [4, 50, 120],
        [3, 8, 25],
        [2, null, 7],
        [1, null, 5],
    ],
    [
        [3, 16, 50],
        [2, 2, 20],
        [1, null, 5],
    ],
    [
        [2, 8, 50],
        [1, null, 10],
    ],
    [[1, 2, 40]],
];

const formatMultiple = (multiple: number) => (multiple ? `${StringUtils.formatNumber(multiple)}x` : "–––");
</script>
